import { loadLazyComponent } from '@wix/communities-forum-client-commons';

export default loadLazyComponent(() => import(/* webpackChunkName: "badge-lib" */ '../badge'));
